import { Doughnut } from 'vue-chartjs'

const OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  legend: { position: 'bottom' }
}

export default {
  extends: Doughnut,
  props: ['chartData'],
  mounted () {
    this.renderChart(this.chartData, OPTIONS)
  },
  watch: {
    chartData: {
      handler (val) {
        if (this.$data._chart) this.$data._chart.destroy()
        this.renderChart(val, OPTIONS)
      },
      deep: true
    }
  }
}
